/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import actions from '../../actions';
import sh from 'components/shared.module.css';
import s from './datasets.module.css';

const { requestDatasets, requestSessionId, openTab } = actions;

const Datasets = () => {
  const dispatch = useDispatch();
  const { datasets } = useSelector(state => ({
    datasets: state.datasets
  }));

  useEffect(
    () => {
      if (!datasets) dispatch(requestDatasets());
    }, [dispatch, datasets]
  );

  const newTab = datasetId => (() => dispatch(openTab(datasetId)));

  const requestNewSessionAndTab = (datasetId, dataset) => {
    dispatch(requestSessionId(datasetId, dataset));
    // spinner
    // newTab(tmp);
  };

  function genDatasets(datasetsObj) {
    return (
      <div className={s.grid}>
        <span>id</span>
        <span>explore</span>
        <span>info</span>
        <span>images</span>
        <span>geo</span>
        {Object.keys(datasetsObj).map(
          groupId => {
            const group = datasets[groupId].datasets;
            return Object.keys(group).map((dts) => {
              const item = group[dts];
              return Object.keys(item).map((k) => {
                return (k === 'explore') ? (
                  <span>{
                    <Button variant='secondary' style={{ fontSize: 12, padding: 4 }} onClick={() => { requestNewSessionAndTab(item.id, item); }}>
                      {item[k]}
                    </Button>
                  }</span>)
                  : (<span>{item[k]}</span> )})
            });
          })
        }</div>
    )}


  const datasetsJsx = (!datasets)
    ? <div>Loading..</div>
    : genDatasets(datasets);

  return ( // calc(100% - 25px - 42px - 2px)
    <div style={{ height: '100vh' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <div style={{ height: 'calc(100% - 40px)', overflow: 'auto' }}>
          <span className='ml-3 mt-3' style={{ fontSize: 10 }}>*mock data below</span>
          <div className={s.gridCont}>
            {datasetsJsx}
          </div>
        </div>
      </div>
    </div>
  );


};

Datasets.defaultProps = {
  datasets: null,
};

Datasets.propTypes = {
  // redux
  datasets: PropTypes.objectOf(PropTypes.object),
};

export default Datasets;
